import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-venmo-payment-view',
  templateUrl: './venmo-payment-view.component.html',
  styleUrls: ['./venmo-payment-view.component.css'],
  imports: []
})
export class VenmoPaymentViewComponent {
  @Input() venmoCodeExists: boolean = false;
  @Input() venmoCodeUrl: string = '';
  @Input() venmoProfileUrl: string = '';
}
